import { useFormContext } from "react-hook-form";
import { Grid } from "@mui/material";
import { Input } from "@/components/elements/Input";
import { FormField } from "@/components/elements/FormField";
import { FCC } from "@/types/common";
import { TCaseBasicInfo } from "@/features/case/types/case";
import { Select } from "@/components/elements/Select";
import React from "react";
import { useGetUserListPersonInCharge } from "@/api/services/main/user";

type CaseBasicInfoFormProps = {};

export const CaseBaseInfoForm: FCC<CaseBasicInfoFormProps> = () => {
  const methods = useFormContext<TCaseBasicInfo>();
  const { control } = methods;
  const { userOptions } = useGetUserListPersonInCharge();

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <FormField control={control} name="name">
          <Input />
        </FormField>
      </Grid>
      <Grid item xs={4}>
        <FormField control={control} name="managementNumber">
          <Input />
        </FormField>
      </Grid>
      <Grid item xs={4}>
        <FormField control={control} name="personInChargeId">
          <Select options={userOptions} isShowIconComponent={false} />
        </FormField>
      </Grid>
    </Grid>
  );
};
